// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qvbBz","productName":"Table_productName__2iGJR"};